import { pgTable, text, serial, integer, boolean, jsonb, timestamp } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod";

export const users = pgTable("users", {
  id: serial("id").primaryKey(),
  username: text("username").notNull().unique(),
  password: text("password").notNull(),
  credits: integer("credits").notNull().default(20),
  referralCode: text("referral_code").unique(), // Removed notNull constraint
  referredBy: integer("referred_by").references(() => users.id),
});

export const chatHistory = pgTable("chat_history", {
  id: serial("id").primaryKey(),
  userId: integer("user_id").references(() => users.id).notNull(),
  prompt: text("prompt").notNull(),
  response: text("response").notNull(),
  isFavorite: boolean("is_favorite").default(false),
  createdAt: timestamp("created_at").defaultNow(),
});

export const files = pgTable("files", {
  id: serial("id").primaryKey(),
  userId: integer("user_id").references(() => users.id).notNull(),
  name: text("name").notNull(),
  content: text("content"),
  folderId: integer("folder_id").references(() => folders.id),
  isFavorite: boolean("is_favorite").default(false),
  shareId: text("share_id").unique(),
  createdAt: timestamp("created_at").defaultNow(),
});

export const folders = pgTable("folders", {
  id: serial("id").primaryKey(),
  userId: integer("user_id").references(() => users.id).notNull(),
  name: text("name").notNull(),
  createdAt: timestamp("created_at").defaultNow(),
});

export const notifications = pgTable("notifications", {
  id: serial("id").primaryKey(),
  userId: integer("user_id").references(() => users.id).notNull(),
  message: text("message").notNull(),
  read: boolean("read").default(false),
  createdAt: timestamp("created_at").defaultNow(),
});

export const contacts = pgTable("contacts", {
  id: serial("id").primaryKey(),
  name: text("name").notNull(),
  email: text("email").notNull(),
  message: text("message").notNull(),
  createdAt: timestamp("created_at").defaultNow(),
});

// Insert schemas
export const insertUserSchema = createInsertSchema(users).pick({
  username: true,
  password: true,
  referralCode: true, // Added referralCode to the schema
});

export const insertChatSchema = createInsertSchema(chatHistory).pick({
  prompt: true,
});

export const insertFileSchema = createInsertSchema(files).pick({
  name: true,
  content: true,
  folderId: true,
}).extend({
  content: z.string().optional(),
});

export const insertFolderSchema = createInsertSchema(folders).pick({
  name: true,
});

export const insertContactSchema = createInsertSchema(contacts);

// Types
export type InsertUser = z.infer<typeof insertUserSchema>;
export type User = typeof users.$inferSelect;
export type ChatHistory = typeof chatHistory.$inferSelect;
export type File = typeof files.$inferSelect;
export type Folder = typeof folders.$inferSelect;
export type Notification = typeof notifications.$inferSelect;
export type Contact = typeof contacts.$inferSelect;